const reasons = [
  {
    icon: 'ri-focus-3-line',
    title: 'Мы не начинаем развитие с тренинга',
    desc: 'Сначала определяем, какую роль должен быть готов выполнять сотрудник и какие компетенции для неё необходимы.',
  },
  {
    icon: 'ri-radar-line',
    title: 'Оцениваем реальную ситуацию',
    desc: 'Развитие строится на текущем уровне сотрудника, а не на предположениях.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Связываем развитие с практикой',
    desc: 'Новые компетенции должны проявляться в реальной работе.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Используем разные инструменты',
    desc: 'Не каждый дефицит требует тренинга. Иногда эффективнее практика, наставничество, проектная задача или индивидуальная работа.',
  },
  {
    icon: 'ri-team-line',
    title: 'Работаем с руководителями',
    desc: 'Руководитель является важной частью системы развития сотрудника.',
  },
  {
    icon: 'ri-loop-left-line',
    title: 'Возможна повторная оценка',
    desc: 'Она позволяет увидеть, насколько изменился уровень компетенций.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Принципы, на которых строится работа с кадровым резервом
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-base md:text-lg font-medium text-gray-800 mt-10 max-w-3xl mx-auto leading-relaxed">
          Наша задача — не сформировать красивый список резервистов, а подготовить людей к реальным будущим ролям.
        </p>
      </div>
    </section>
  );
}